module.exports = __webpack_public_path__ + "img/layanan-properti.b2fea301.webp";